import { render, staticRenderFns } from "./citizen-science.vue?vue&type=template&id=77201063&"
import script from "./citizen-science.vue?vue&type=script&lang=js&"
export * from "./citizen-science.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports